'use client';

import React from 'react';
import Link from 'next/link';
import Button from '@/components/common/Button';
import { faArrowUpRightFromSquare, faUnlockKeyhole } from '@fortawesome/pro-duotone-svg-icons';
import { event } from '@/utils/googleAnalytics';
import { useDispatch } from 'react-redux';
import { FeatureType, openModal } from '@/slices/features/modalSlice';
import { getSourcePath } from '@/rewrites';

interface TenderAccessButtonProps {
  tenderId: string;
  hasAccess: boolean;
  label: string;
  isAuthenticated: boolean;
}

const TenderAccessButton: React.FC<TenderAccessButtonProps> = ({ tenderId, hasAccess, label, isAuthenticated }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(openModal(FeatureType.TENDER_ACCESS));
  };

  if (isAuthenticated) {
    if (hasAccess) {
      return (
        <Link
          href={`${window.location.pathname}/quelle?tenderId=${tenderId}`}
          className="flex items-center"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            event({
              action: 'click',
              category: 'outbound',
              label: 'External link clicked',
              value: 'Submission URL',
            });
          }}
        >
          <Button icon={faArrowUpRightFromSquare} label={label} />
        </Link>
      );
    } else {
      return <Button icon={faArrowUpRightFromSquare} locked={true} label={label} onClick={handleClick} />;
    }
  } else {
    return (
      <Link href={`${getSourcePath('/registration')}`} target="_blank" rel="noopener noreferrer">
        <Button icon={faUnlockKeyhole} label="Kostenlos freischalten" />
      </Link>
    );
  }
};

export default TenderAccessButton;
